import { SearchDocumentType } from '@wix/client-search-sdk';
export var Alignment;
(function (Alignment) {
    Alignment["Left"] = "left";
    Alignment["Center"] = "center";
    Alignment["Right"] = "right";
})(Alignment || (Alignment = {}));
export var searchResultsSettings = {
    isSearchBarEnabled: {
        key: 'isSearchBarEnabled',
        getDefaultValue: function () {
            return true;
        },
    },
    searchBarPlaceholder: {
        key: 'searchBarPlaceholder',
        getDefaultValue: function () {
            return 'Search...';
        },
    },
    itemsPerPage: {
        key: 'itemsPerPage',
        getDefaultValue: function () {
            return 10;
        },
    },
    isResultsMessageWithQuery: {
        key: 'isResultsMessageWithQuery',
        getDefaultValue: function () {
            return false;
        },
    },
    isResultsMessageWithNumber: {
        key: 'isResultsMessageWithNumber',
        getDefaultValue: function () {
            return true;
        },
    },
    isResultsEmptyMessageWithNumber: {
        key: 'appLayout',
        getDefaultValue: function () {
            return false;
        },
    },
    isResultsEmptyMessageWithQuery: {
        key: 'isResultsEmptyMessageWithQuery',
        getDefaultValue: function () {
            return false;
        },
    },
    resultsMenuAlignment: {
        key: 'resultsMenuAlignment',
        getDefaultValue: function () {
            return Alignment.Left;
        },
    },
    paginationAlignment: {
        key: 'paginationAlignment',
        getDefaultValue: function () {
            return Alignment.Center;
        },
    },
    categoryList: {
        key: 'categoryList',
        getDefaultValue: function () {
            var _a;
            return _a = {},
                _a[SearchDocumentType.All] = {
                    index: 100,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a[SearchDocumentType.Products] = {
                    index: 101,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a[SearchDocumentType.Bookings] = {
                    index: 102,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a[SearchDocumentType.Events] = {
                    index: 102.5,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a[SearchDocumentType.Blogs] = {
                    index: 103,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a[SearchDocumentType.Pages] = {
                    index: 104,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a[SearchDocumentType.Forums] = {
                    index: 105,
                    visible: true,
                    override: '',
                    useOverride: false,
                },
                _a;
        },
    },
};
//# sourceMappingURL=searchResultsSettings.js.map